import createWithBsPrefix from './createWithBsPrefix';
var FigureCaption = createWithBsPrefix('figure-caption', {
  Component: 'figcaption'
});
export default FigureCaption;